import { getEnvironmentVariable } from './get-environment-variable';

export const ENV = {
  VITE_API_URL: getEnvironmentVariable('VITE_API_URL'),
  VITE_PROCESSING_SERVICE: getEnvironmentVariable('VITE_PROCESSING_SERVICE'),
  VITE_ACCESS_SERVICE: getEnvironmentVariable('VITE_ACCESS_SERVICE'),
  VITE_PRODUCT_SERVICE: getEnvironmentVariable('VITE_PRODUCT_SERVICE'),
  IS_DEVELOPMENT_MODE: import.meta.env.DEV,
} as const;
